import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var ListHeaderItem = function (_a) {
    var children = _a.children, title = _a.title, rest = __rest(_a, ["children", "title"]);
    return (React.createElement("div", { className: "lists-title-row-item" },
        React.createElement("p", __assign({ className: "lists-title-row-item-txt", title: title }, rest), children)));
};

export { ListHeaderItem };
